import { Fragment } from 'react'
import { FormattedMessage } from 'react-intl'
import GreatDiving from './GreatDiving'
import { OperatorListItem, OperatorListItemLoader } from './OperatorListItem'

export default function OperatorList({
  isLoading,
  items,
  bulletPointsTitle,
  bulletPoints,
  eCommerceListName,
  showMore,
  page,
  hasNextPage,
}) {
  const itemsLength = items.length
  function renderBulletPoints(index, itemsLength) {
    let showBulletPoints = false
    let className = ''
    if(itemsLength < 8 && index === itemsLength) {
      showBulletPoints = true
      className = 'border-top no-padding'
    } else if(itemsLength >= 8 && itemsLength < 12 && index === 4) {
      className = 'border-bottom border-top'
      showBulletPoints = true
    } else if(itemsLength >= 12 && index === 8) {
      showBulletPoints = true
      className = 'border-bottom border-top'
    }

    if(showBulletPoints) {
      return (
        <GreatDiving
          title={bulletPointsTitle}
          bulletPoints={bulletPoints}
          className={className}
        />
      )
    }
  }

  return (
    <div
      className={`operators-list ${isLoading ? 'placeholder-animation' : ''}`}
    >
      {isLoading && page === 1 ? (
        <Fragment>
          {[...new Array(8)].map((_, i) => (
            <OperatorListItemLoader key={i} />
          ))}
        </Fragment>
      ) : (
        <Fragment>
          {items.map((item, index) => {
            return (
              <Fragment key={item.slug}>
                <OperatorListItem
                  item={item}
                  eCommerceListName={eCommerceListName}
                />
                {renderBulletPoints(index + 1, itemsLength)}
              </Fragment>
            )
          })}
          {hasNextPage && (
            <div className='text-center w100'>
              <button className='btn-red' onClick={showMore}>
                <FormattedMessage id='show_more' defaultMessage='Show more' />
              </button>
            </div>
          )}
        </Fragment>
      )}
    </div>
  )
}
